import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { fetchPayroll } from "./store/PayrollDataSlice";
import PayrollTable from "./PayrollTable";


const Payroll = () => {
  const dispatch = useDispatch();
  const {
    data = [],
    loading = false,
    isModalOpen = false,
  } = useSelector((state) => state.payrollData || {});

  useEffect(() => {
    dispatch(fetchPayroll());
  }, [dispatch]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Payroll"
            title="Dashboard"
            subtitle="Payroll"
            name="Add Payroll"
            // onAddClick={() => dispatch(openModal())} 
          />
          <PayrollTable data={data} loading={loading} />

          {/* <AddUserDataModal
            show={isModalOpen}
            onClose={() => dispatch(closeModal())}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default Payroll;
